import React from 'react';

const modalDialogBody = "_modal-dialog-body_snegq_1";
const modalDialogBodyInner = "_modal-dialog-body-inner_snegq_36";
const styles = {
	modalDialogBody: modalDialogBody,
	modalDialogBodyInner: modalDialogBodyInner
};

const ModalDialogBody = ({ children, textAlign = "start" }) => {
  return React.createElement(
    "div",
    { className: styles.modalDialogBody, "data-text-align": textAlign, "data-zds": true },
    React.createElement("div", { className: styles.modalDialogBodyInner, "data-zds": true }, children)
  );
};

export { ModalDialogBody };
//# sourceMappingURL=Body.es.js.map
